import { useQuery } from '@tanstack/react-query';
import { ResponseObject } from '../../interfaces/App';
import Knowledge from '../../interfaces/Knowledge';
import { getKnowledgesByUserId } from '../../services/knowledgeService';

export const useKnowledges = (userId: string | undefined, enabled = true) => {
  return useQuery<ResponseObject, Error>({
    queryKey: ['knowledges', userId],
    queryFn: async () => {
      if (!userId) {
        return { message: [] };
      }
      return await getKnowledgesByUserId(userId);
    },
    enabled: enabled && !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    // Don't set refetchOnMount to false - let React Query refetch stale data
    // This allows cache invalidation to work properly
    refetchOnMount: 'always', // Always refetch on mount to pick up invalidated data
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
    select: data => ({
      ...data,
      message: data.message as Knowledge[],
    }),
  });
};
